
const MuiFormControl = {
  marginNormal: {
    marginTop: '0',
    marginBottom: '16px',
  }
};

export default MuiFormControl;  